export default "__VITE_ASSET__gl3LYYpA__"